import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden bg-emerald-700">
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-700 via-emerald-600 to-emerald-700" />
      <div className="relative z-10 mx-auto flex w-full max-w-3xl flex-col items-center px-4 py-16 text-center md:px-6 md:py-20">
        <h2 className="font-heading text-2xl font-bold text-white md:text-4xl">
          {t('finalCta.title')}
        </h2>
        <p className="mt-4 max-w-xl text-sm leading-relaxed text-emerald-50 md:text-base">
          {t('finalCta.body')}
        </p>

        <div className="mt-8 flex w-full flex-col items-center gap-3 sm:flex-row sm:justify-center">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-white px-6 py-3.5 text-base font-semibold text-emerald-700 transition-colors hover:bg-emerald-50 sm:w-auto"
          >
            <i className="ri-external-link-line"></i>
            {t('finalCta.primary')}
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/40 bg-transparent px-6 py-3.5 text-base font-semibold text-white transition-colors hover:bg-white/10 sm:w-auto"
          >
            {t('finalCta.secondary')}
          </a>
        </div>
      </div>
    </section>
  );
}